import styled from "styled-components";
import ScrollContainer from "react-indiana-drag-scroll";

// 카테고리
export const FlexCommunityDiv = styled.div`
  overflow-x: auto;

  -ms-overflow-style: none; // IE and Edge
  scrollbar-width: none; // Firefox

  &::-webkit-scrollbar {
    display: none; // Chrome, Safari, Opera
  }
`;

export const CategoryList = styled(ScrollContainer)`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 48px;
`;

export const CategoryDiv = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 10px;
  box-sizing: border-box;
  padding: 4px 8px;
  cursor: pointer;
  border: 1px solid #dfe2e6;
  border-radius: 8px;

  &:first-child {
    margin-left: 0;
  }

  & div {
    font-size: 14px;
    text-align: center;
    letter-spacing: -0.01em;
    flex: none;
    cursor: pointer;
  }

  &.select {
    background: #ff7a00;
    border: 1px solid #ff7a00;
    border-radius: 8px;
    box-sizing: border-box;

    font-weight: 600;
    color: #fff;

    & div {
    }
  }
`;

export const NoPost = styled.div`
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
`;

// 글작성 버튼
export const FloatingDiv = styled.div`
  width: 48px;
  height: 48px;
  background-color: #ff7a00;
  border-radius: 50px;
  position: fixed;
  bottom: 78px;
  right: 16px;
  z-index: 200;
  cursor: pointer;

  & img {
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
`;

export const H2 = styled.h2`
  margin-top: 24px;
  margin-bottom: -8px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.02em;
`;
